import { Platform } from 'react-native';

type TestProps = {
  testID?: string;
  'data-testid'?: string;
};

const getTestProps = (
  testID: string | undefined,
  platform: string = Platform.OS,
): TestProps => {
  if (!testID) {
    return {};
  }

  return platform === 'web' ? { 'data-testid': testID } : { testID };
};

export { getTestProps };
